import './header.scss';
import AOS from 'aos';

export default async () => {
	// Sticky menu
	$( window ).scroll( function () {
		if ( $( this ).scrollTop() > 150 ) {
			$( '.header' ).addClass( 'header--sticky' );
		} else {
			$( '.header' ).removeClass( 'header--sticky' );
		}
	} );

	// Toggle-menu
	let $jsToggleMenu = $( '.js-toggle-menu' );

	$jsToggleMenu.click( function ( e ) {
		e.preventDefault();
		$( '.header__menu' ).toggleClass( '' );
		$( 'body' ).toggleClass( 'is-menu-open' );
	} );

	// Toggle-menu
	$( '.header__menu > ul > li > ul, .header__menu > ul > li > ul > li > ul' ).parent( 'li' ).addClass( 'has-children' );
	$( '.header__menu-item' ).click( function (  ) {
		let $this = $( this ).find( '.header__menu-link' );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.header__menu-link' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.has-children ul' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );

	// Scroll
	$( '.js-scroll-btn' ).click( function ( e ) {
		e.preventDefault();
		let target = $( this ).closest( '.vc_row' ).next();

		if ( target.length ) {
			let scrollTo = target.offset().top - 120;

			$( 'body, html' ).animate( {
				scrollTop: scrollTo,
			}, 1000 );
		}
	} );

	$( window ).scroll( function () {
		if ( $( this ).scrollTop() > 750 ) {
			$( '.js-scroll-bottom' ).fadeIn();
		} else {
			$( '.js-scroll-bottom' ).fadeOut();
		}
	} );
	$( '.js-scroll-bottom' ).click( function () {
		$( 'html, body' ).animate( {
			scrollTop: 0,
		}, 1500 );

		return false;
	} );

	AOS.init( {
		once: true,
		offset: 100,
		duration: 800,
	} );
	let scrollRef = 0;

	window.addEventListener( 'scroll', function () {
		scrollRef <= 10 ? scrollRef++ : AOS.refresh();
	} );
};
